<template>
  <div
    style="height:100%;background-color: rgb(153, 204, 204,0.2);padding: 14px 20px;box-sizing: border-box;"
  >
    <el-row>
      <el-select
        v-model="porjictId"
        placeholder="请选择项目"
        @change="xmjinzhang"
        style="margin-top:20px;"
      >
        <el-option
          v-for="item in useporject"
          :key="item.project_id"
          :label="item.project_name_cn"
          :value="item.project_id"
        ></el-option>
      </el-select>
      <span style="padding-left:20px;">
        项目完结：
        <b style="color:red" v-if="all_payed == 1">已完结</b>
        <b style="color:green" v-if="all_payed == 0">未完结</b>
        <el-button
          style="margin-left:10px;"
          size="mini"
          type="info"
          plain
          v-if="all_payed == 0 && qx == '101'"
          @click="confirmwanjie"
        >点击确认当前项目完结</el-button>
      </span>
    </el-row>
    <h2 align="center" style="color: #3b3b3b;margin-top:20px;">{{porject}}</h2>
    <!-- <get-table :porjectId.sync="porjictId"></get-table> -->
    <table>
      <thead>
        <tr>
          <th style="background-color:#ccc;color:#424242">项目流程</th>
          <th v-for="(item,index) of jieduanList" :key="index">
            {{item.phase_abbr}}
            <br />
            {{item.phase_name_cn}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) of bumenList" :Key="index">
          <td style="background-color:#fff;width:5%;">{{item.depart_name}}</td>
          <td
            v-for="(ele,id) of jieduan[index]"
            :Key="id"
            :class="[{green:ele.is_done == 1},{red:ele.is_done == 0}]"
            @click="djdanyuange(ele)"
          ></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import { getBaseInfo } from "@/api/user";
export default {
  // name: "porjectProgress",
  // components: {
  //   GetTable
  // },
  data() {
    return {
      tableData: [],
      useporject: [],
      porject: "",
      porjictId: "",
      bumenList: [],
      jieduan: [],
      jieduanList: [],
      allList: [],
      all_payed: "",
      qxianlist: [],
      qx: ""
    };
  },
  created() {
    this.getTableData();
    this.getuserInfo();
  },
  methods: {
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      // console.log(uesrInfo.qxianlist);
      this.qxianlist = uesrInfo.qxianlist;
      //console.log(this.qxianlist.includes("4"));
      if (this.qxianlist.includes("4")) {
        this.qx = 101;
      }
    },
    getTableData() {
      getBaseInfo().then(data => {
        //项目列表
        //console.log(data.project_list);
        let newporject = data.project_list;
        let useList = {};
        Object.assign(useList, newporject);
        delete useList[9];
        delete useList[16];
        delete useList[23];
        this.useporject = Object.values(useList);
        this.useporject.sort(function(a,b){
          return  a.order_id - b.order_id
        })
        //console.log(this.useporject);
        this.porject = this.useporject[0].project_name_cn;
        this.porjictId = this.useporject[0].project_id;
        this.all_payed = this.useporject[0].all_payed;
        //console.log(this.porjictId);
        this.getliebiaoshuju(this.porjictId);
      });
    },

    //获取列表数据
    getliebiaoshuju(porjectId) {
      axios
        .get(
          IPConfig.IP +
            "/kpi-management/depart_project_phases/info.php?project_id=" +
            porjectId
        )
        .then(res => {
          //console.log(res.data);

          if (0 == res.data.errcode) {
            this.allList = res.data;
            this.bumenList = res.data.departs;
            this.jieduan = res.data.depart_project_phases;
            this.jieduanList = res.data.phases;
          } else {
            console.log(res.data.errmsg);
          }
        })
        .catch(error => {
          //console.log(error);
        });
    },
    //点击确认阶段是否完成
    //@click="djdanyuange(ele)"
    djdanyuange(ele) {
      //console.log(ele)
      //部门权限
      if (!this.qxianlist.includes("4")) {
        return;
      }

      if (ele.is_done == 1) {
        return;
      } else if (ele.is_done == 0) {
        for (let key in this.allList.departs) {
          if (ele.depart_id == this.allList.departs[key].depart_id) {
            ele.depart_name = this.allList.departs[key].depart_name;
          }
        }
        for (let key in this.allList.phases) {
          if (ele.phase_id == this.allList.phases[key].phase_id) {
            ele.phase_name_cn =
              this.allList.phases[key].phase_abbr +
              this.allList.phases[key].phase_name_cn;
          }
        }
        this.$confirm(
          "确定" +
            '"' +
            ele.depart_name +
            '"' +
            "部" +
            '"' +
            ele.phase_name_cn +
            '"' +
            "阶段过了吗？确定了无法取消哦！",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            ele.is_done = 1;
            //console.log(ele);
            axios
              .post(
                IPConfig.IP +
                  "/kpi-management/depart_project_phases/update.php",
                {
                  depart_project_phases_id: ele.depart_project_phases_id,
                  is_done: ele.is_done
                }
              )
              .then();
          })
          .catch(e => e);
      }
    },
    xmjinzhang() {
      //console.log(this.porjictId);
      for (let key in this.useporject) {
        if (this.porjictId == this.useporject[key].project_id) {
          this.porject = this.useporject[key].project_name_cn;
          this.all_payed = this.useporject[key].all_payed;
        }
      }

      this.getliebiaoshuju(this.porjictId);
      // console.log(index);
    },
    confirmwanjie() {
      //console.log(this.porjictId);
      for (let key in this.useporject) {
        if (this.porjictId == this.useporject[key].project_id) {
          var xiangmuName = this.useporject[key].project_name_cn;
        }
      }
      this.$confirm(
        "确定" + '"' + xiangmuName + '"' + "项目已完结吗？确定了无法取消哦！",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          //console.log(this.porjictId);
          axios
            .post(IPConfig.IP + "/kpi-management/project/all_payed.php", {
              project_id: this.porjictId,
              all_payed: 1
            })
            .then(res => {
              this.all_payed = 1;
            });
        })
        .catch(e => e);
    }
  }
};
</script>
<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  width: 7%;
  height: 60px;
  border: 1px solid #cccccc;
  font-size: 12px;
  text-align: center;
}
th {
  background-color: #3f3f3f;
  color: #fff;
  height: 80px;
  font-size: 14px;
}
.green {
  background-color: rgb(0, 160, 0);
}
.red {
  background-color: rgb(200, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/views/porjectProgress/index.vue